module.exports = __webpack_public_path__ + "img/266.3d97ec94.jpg";